/**
 * Index comparison (MultiLineChart) stroke preferences.
 * Stored on user.appSettings.marketOverviewChartStyle.
 *
 * lineStyle values match lightweight-charts LineStyle enum:
 *   Solid=0, Dotted=1, Dashed=2, LargeDashed=3, SparseDotted=4
 */

export const MARKET_OVERVIEW_CHART_STYLE_KEY = 'marketOverviewChartStyle';

export const MARKET_OVERVIEW_LINE_WIDTH_OPTIONS = [
  { value: 1, label: '1px' },
  { value: 2, label: '2px' },
  { value: 3, label: '3px' },
  { value: 4, label: '4px' },
];

export const MARKET_OVERVIEW_LINE_STYLE_OPTIONS = [
  { value: 0, label: 'Solid' },
  { value: 1, label: 'Dotted' },
  { value: 2, label: 'Dashed' },
  { value: 3, label: 'Large dash' },
];

export const DEFAULT_MARKET_OVERVIEW_CHART_STYLE = {
  lineWidth: 1,
  lineStyle: 0, // Solid
};

export function normalizeMarketOverviewChartStyle(raw) {
  const width = Number(raw?.lineWidth);
  const style = Number(raw?.lineStyle);
  return {
    lineWidth: MARKET_OVERVIEW_LINE_WIDTH_OPTIONS.some((o) => o.value === width)
      ? width
      : DEFAULT_MARKET_OVERVIEW_CHART_STYLE.lineWidth,
    lineStyle: MARKET_OVERVIEW_LINE_STYLE_OPTIONS.some((o) => o.value === style)
      ? style
      : DEFAULT_MARKET_OVERVIEW_CHART_STYLE.lineStyle,
  };
}
